var _rect, _line, _line2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsDefault(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.424242,
    y: 0.424242,
    width: 27.1515,
    height: 27.1515,
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 0.848485
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1.14764,
    y1: 0.548648,
    x2: 28.2992,
    y2: 27.7002,
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 0.848485
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0.547672,
    y1: 27.7,
    x2: 27.6992,
    y2: 0.548501,
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 0.848485
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsDefault);
export default __webpack_public_path__ + "static/media/icons_default.7194884ccf9bb0b470a811da12caaea2.svg";
export { ForwardRef as ReactComponent };